import http from "@/util/http.js"

// v1/exam/companyList 获取考试单位信息
export function companyList(data,token){
    return http.post("v1/exam/companyList",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        // custom: {auth: true}
    })
}
///api/v1/exam/loadBmbById  获取报名表图片
export function loadBmbById(data,token){
    return http.post("v1/exam/loadBmbById",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}
///api/v1/exam/examination_card 获取面试信息
export function loadMsbById(data,token){
    return http.post("v1/exam/loadMsbById",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}
// v1/exam/positionList 获取考试岗位信息
export function positionList(data,token){
    return http.post("v1/exam/positionList",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        // custom: {auth: true}
    })
}

//  v1/exam/firstSignUp 首次报考
export function firstSignUp(data,token){
    return http.post("v1/exam/firstSignUp",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        // custom: {auth: true}
    })
}

// v1/exam/dictdataconfig 字典数据列表
export function dictdataconfig(data,token){
    return http.post("v1/exam/dictdataconfig",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        // custom: {auth: true}
    })
}
//获取报名进度
export function baomingjindu(data){
    return http.post("v1/exam/baomingjindu",data,{
        header: {"content-type":"application/json;charset=UTF-8"},

    })
}
//v1/auth/login  登录
export function login(data,token){
    return http.post("v1/auth/login",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        // custom: {auth: true}
    })
}

// v1/exam/examinee_info 获取报名信息
export function examineeInfo(data,token){
    return http.post("v1/exam/examinee_info",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}


// v1/exam/updateExamineeInfo 修改考试报名信息
export function updateExamineeInfo(data,token){
    return http.post("v1/exam/updateExamineeInfo",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}

// v1/exam/submitExamineeInfo 提交审核信息
export function submitExamineeInfo(data,token){
    return http.post("v1/exam/submitExamineeInfo",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}

//v1/exam/uploadPhoto 上传头像
export function uploadPhoto(data,token){
    return http.post("v1/exam/uploadPhoto",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}

// v1/exam/examination_result 考试成绩
export function examinationResult(data,token){
    return http.post("v1/exam/examination_result",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}

//v1/auth/seeuserinfo 验证用户找回密码和报名序号信息
export function seeuserinfo(data,token){
    return http.post("v1/auth/seeuserinfo",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: false}
    })
}
///v1/auth/getPhoneCode 验证姓名与身份证号发送验证码
export function getPhoneCode(data,token){
    return http.post("v1/auth/getPhoneCode",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: false}
    })
}
// v1/auth/checkPhoneCode 验证短信验证码
export function checkPhoneCode(data,token){
    return http.post("v1/auth/checkPhoneCode",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
         custom: {auth: false}
    })
}
//v1/auth/changepassword 重置密码
export function changepassword(data,token){
    return http.post("v1/auth/changepassword",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: false}
    })
}

//v1/exam/adminexaminationinfo 获取考试列表
export function examList(data,token){
    return http.post("v1/exam/adminexaminationinfo",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: false}
    })
}

//v1/exam/submitpay 缴费
export function submitpay(data,token){
    return http.post("v1/exam/submitpay",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}

// v1/exam/adminexaminationinfobyid  根据id查询考试列表
export function examDetail(data,token){
    return http.post("v1/exam/adminexaminationinfobyid",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: false}
    })
}

//getpositionbyid
export function getpositionbyid(data){
    return http.post("v1/exam/getpositionbyid",data,{
        header: {"content-type":"application/json;charset=UTF-8"},

    })
}
///api/v1/exam/printCard
export function printCard(data,token){
    return http.post("v1/exam/printCard",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}

///api/v1/exam/examination_card 获取准考证信息
export function examinationCard(data,token){
    return http.post("v1/exam/examination_card",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}
///api/v1/exam/wxPay/unifiedOrder 获取准考证信息
export function unifiedOrder(data,token){
    return http.post("wxPay/unifiedOrder",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}
///api/v1/exam/wxPay/orderquery 获取准考证信息
export function orderquery(data,token){
    return http.post("wxPay/orderquery",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}
///api/v1/exam/wxPay/orderquery 获取准考证信息
export function loadZkzById(data,token){
    return http.post("v1/exam/loadZkzById",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}
///user_chehui  撤回审核
export function user_chehui(data,token){
    return http.post("v1/exam/user_chehui",data,{
        header: {"content-type":"application/json;charset=UTF-8",'token':token},
        custom: {auth: true}
    })
}

